<div class="l-tables mt-2">
    <app-main-scoreboard class="table" [items]="mainScoreboard$ | async" [height]="boxHeight"></app-main-scoreboard>

    @if (settings(); as settings) {
        @switch (settings.teamsScoreboardMode) {
            @case (teamsScoreboardMode.EloPoints) {
                <app-elo-scoreboard
                    class="table d-none d-md-flex"
                    [height]="boxHeight"
                    [items]="eloScoreboard$ | async"
                ></app-elo-scoreboard>
            }
            @default {
                <app-teams-scoreboard
                    class="table d-none d-md-flex"
                    [height]="boxHeight"
                    [items]="teamScoreboard$ | async"
                ></app-teams-scoreboard>
            }
        }
    }
</div>
<div class="l-newMatch d-none d-xxl-flex">
    <span class="fsFAB_add" (click)="addMatchModal()">
        <i class="material-icons">add</i>
        <span class="">{{ 'DASHBOARD.ADD_MATCH' | translate }}</span>
    </span>
</div>

@if (matches?.length === 0) {
    <div class="mt-4 text-center d-none d-xxl-flex flex-column align-items-center">
        <mat-icon>arrow_upward</mat-icon>
        {{ 'DASHBOARD.NEW_MATCH_CTA' | translate }}
    </div>
}

@if (matches?.length) {
    <div class="mt-4 text-center">
        <mat-checkbox color="primary" (change)="onlyMineChanged()" [(ngModel)]="showOnlyMineMatches">{{
            'DASHBOARD.SHOW_ONLY_MINE' | translate
        }}</mat-checkbox>
    </div>
}

@for (m of ongoingMatches$ | async; track m; let first = $first) {
    <app-ongoing-match-box [match]="m" [first]="first"></app-ongoing-match-box>
}

<div infinite-scroll (scrolled)="loadNext()" [infiniteScrollThrottle]="300">
    @for (m of matches; track m) {
        <app-match-box
            #matchBox
            [attr.data-match-id]="m.id"
            [match]="m"
            (matchDeleted)="onMatchDeleted($event)"
            (matchEdit)="onMatchEdit($event)"
        ></app-match-box>
    }
</div>
